import { Injectable } from '@angular/core';
import { AlertService } from '../alert-service/alert.service';
import { HttpClient, HttpContext } from '@angular/common/http';
import { CrossSellGateway } from '@domain/models/cross-sell/gateway/cross-sell.gateway';
import { environment } from '@environments/environment';
import { BoarwalkResources } from '@domain/models/cross-sell/boardwalk-resources.model';
import { catchError, map, Observable, of } from 'rxjs';
import { AlertPosition, AlertType } from '@domain/enums/alert/alert-type.enum';

@Injectable({
  providedIn: 'root',
})
export class CrossSellService extends CrossSellGateway {
  constructor(
    private _alertService: AlertService,
    private _http: HttpClient
  ) {
    super();
  }

  getBoardwalkPage(boardwalk: string): Observable<BoarwalkResources> {
    this._alertService.setLoading(true);
    return this._http.get<any>(`${environment.memberPortalServiceURL.replace('{{brandDomain}}', window.location.host)}/settings/boardwalkresources?boardwalk=${boardwalk}`).pipe(
      map((boardwalkResourcesResponse: BoarwalkResources) => {
        this._alertService.setLoading(false);
        return boardwalkResourcesResponse;
      }),
      catchError((e) => {
        console.log(e);
        this._alertService.setLoading(false);
        this._alertService.showAlert({
          type: AlertType.Error,
          title: 'Error',
          description: e?.error?.Message,
          position: AlertPosition.TopCenter,
        });
        return of();
      })
    );
  }
}
